<template>
  <loader v-bind="{ loading }">
    <columns class="is-mobile">
      <column class="is-4">
        <search-bar 
          v-model="filters.search"
          @run-search="runSearch"
          @clear-search="clearSearch"/>
      </column>
    </columns>

    <columns>
      <column>
        <index-row 
          v-for="middleware in middleware" :key="middleware.id"
          :route="{
            name: 'middleware-manager',
            params: {
              ...$route.params,
              middleware: middleware.id
            }}"
            :title="middleware.name">
            <template #right>
              <flex column class="has-text-centered mr-5">
                {{ middleware.routes_count }}
                <span>Routes</span>
              </flex>
              <flex column class="ml-5 mr-5 has-text-centered">
                {{ middleware.bindings_count }}
                <span>Bindings</span>
              </flex>
              <problems 
                class="ml-5"
                column
                :count="middleware.type ? 0 : 1"
              />
            </template>
        </index-row>  
      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import { markMiddlewareAsIdor } from '@/api/environment'

export default {

  name: 'EnvironmentMiddleware',

  data: () => ({
    middleware: [],
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Middleware')
  },

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadMiddleware()
  },

  methods: {
    loadMiddleware() {
      getPath({
        path: 'api' + this.$route.fullPath,
        params: this.filters
      }, ({data}) => {
        this.middleware = data
        this.loading = false
      }, error => {
        this.loading = false
        console.log(error)
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    runSearch() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'environment-middleware',
        params: this.$route.params,
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'environment-middleware',
        params: this.$route.params,
        query: {}
      })
    },
    async markAsIdor(middleware) {
      if(await this.$confirm({
        title: 'Mark Middleware as IDOR protector',
        message: 'This middleware will be marked a protected layer against IDOR attacks.'
      })) {
        markMiddlewareAsIdor({
          environment: this.$route.params.environment,
          middleware: middleware.id,
        }, response => {
          this.$toast.success('Middleware classified')
          this.loadMiddleware()
        }, error => {})
      }
    }
  },

  watch: {
    '$route': 'loadMiddleware'
  }
}
</script>
